module.exports = __webpack_public_path__ + "resources/img/pims.e9b7bfd84cf936a4aaf5f7c2d91aefef.png";